const type = 'SET_SPLIT_INVOICE_AMOUNT_INPUT';

const setSplitInvoiceAmountInput = (data) => ({
  data,
  type,
});

export { type };
export default setSplitInvoiceAmountInput;
